(function(){
'use strict';
/* 本文件是独立 asset，拿不到 section 主 IIFE 的 q() —— 自带一个同名局部函数。
   （这个坑寒过一次：内存主 IIFE 版本里用 q() 是对的，外置后就不存在了） */
var q=function(id){return document.getElementById(id);};
/* ==================== FONT LIBRARY (2026-09-12 · B 档 120 款 Google Fonts) ====================
   铁律 1：字体名含空格时，写进 canvas 的 ctx.font 必须**带引号** —— 全库统一用单引号包裹
           （与 Draw 弹窗既有写法一致）。不带引号会被拆成两个字体族 → 静默 fallback，
           画布上看着"没变化"，实际字体丢了。
   铁律 2：任何把字体渲染成像素的动作（导出 printfile PNG / Draw 落字）之前必须确保字体就绪，
           否则产物里是 fallback 字体，而且**肉眼看不出**。
   加载策略：不预载全库（120 款 × ~30KB ≈ 3.6MB）。
           · 下拉首次展开时懒载 ★Popular 40 款的预览字体（分 4 批 × 10，避免一次 1MB 卡首屏）
           · 其余项名字用系统字体显示，选中时才加载真字体
   依赖：本模块位于**主 IIFE** 内，只能用 q()（主 IIFE 没有 $）。
        字体面板 DOM 来自 snippets/design-board.liquid。
   ============================================================================================ */
var HD_FONT_GROUPS=[
  {g:'★ Popular', f:['Inter','Poppins','Montserrat','Roboto','Open Sans','Bebas Neue','Anton','Oswald','Archivo Black','Righteous','Playfair Display','Lora','Merriweather','Libre Baskerville','Cormorant Garamond','Pacifico','Dancing Script','Great Vibes','Sacramento','Satisfy','Alfa Slab One','Bungee','Monoton','Press Start 2P','VT323','Caveat','Patrick Hand','Shadows Into Light','Indie Flower','Amatic SC','Roboto Mono','Space Mono','JetBrains Mono','Share Tech Mono','IBM Plex Mono','Bangers','Lobster','Permanent Marker','Rye','Rubik Glitch']},
  {g:'Sans', f:['Inter','Poppins','Montserrat','Roboto','Open Sans','Lato','Nunito','Raleway','Work Sans','Rubik','Manrope','DM Sans','Karla','Barlow','Barlow Condensed']},
  {g:'Display', f:['Bebas Neue','Anton','Oswald','Archivo Black','Righteous','Teko','Fjalla One','Chivo','Abril Fatface','Yeseva One','Cinzel','Cinzel Decorative','Saira Condensed','Staatliches','Orbitron']},
  {g:'Serif', f:['Playfair Display','Lora','Merriweather','Libre Baskerville','Cormorant Garamond','EB Garamond','Crimson Text','Spectral','Source Serif 4','PT Serif','Noto Serif','Bitter','Domine','Cardo','Volkhov']},
  {g:'Script', f:['Pacifico','Dancing Script','Great Vibes','Sacramento','Satisfy','Allura','Alex Brush','Parisienne','Kaushan Script','Yellowtail','Courgette','Marck Script','Cookie','Tangerine','Italianno']},
  {g:'Retro', f:['Alfa Slab One','Bungee','Monoton','Press Start 2P','VT323','Bungee Shade','Bungee Inline','Rubik Mono One','Audiowide','Silkscreen','Bowlby One','Titan One','Ultra','Graduate','Jersey 25']},
  {g:'Handwriting', f:['Caveat','Patrick Hand','Shadows Into Light','Indie Flower','Amatic SC','Gloria Hallelujah','Architects Daughter','Gochi Hand','Kalam','Neucha','Reenie Beanie','Rock Salt','Homemade Apple','Just Another Hand','Nothing You Could Do']},
  {g:'Mono', f:['Roboto Mono','Space Mono','JetBrains Mono','Share Tech Mono','IBM Plex Mono','Source Code Pro','Fira Code','Inconsolata','Ubuntu Mono','Cousine','Anonymous Pro','Major Mono Display','Cutive Mono','Nova Mono','Overpass Mono']},
  {g:'Special', f:['Bangers','Lobster','Permanent Marker','Rye','Rubik Glitch','Luckiest Guy','Chewy','Boogaloo','Shrikhand','Emblema One','Kelly Slab','Slackey','Creepster','Nosifer','Ewert']},
  {g:'System', f:['Arial','Helvetica','Georgia','Times New Roman','Courier New','Verdana','Impact','Trebuchet MS','Palatino Linotype','Comic Sans MS']}
];
var hdFontLoaded={}, hdFontPending=[], hdPrevNames={}, hdFontPrevStarted=false;
/* System 组：访客机器上的系统字体，**不能**向 Google Fonts 请求（css2 对不存在的族直接 400） */
var HD_SYS_FONTS={'arial':1,'helvetica':1,'georgia':1,'times new roman':1,'courier new':1,'verdana':1,'impact':1,'trebuchet ms':1,'palatino linotype':1,'comic sans ms':1};

/* 2026-10-01（用户裁决）：**默认字体 = ★Popular 第一个**（原为 Arial）。
   为什么改：Arial 属**最后一组 System** —— 经引擎 `hdDrawFontsFill()` 的 `keep` 传递后会落到列表**末尾**
   （实测 selectedIndex=160/170）⇒ 下拉一打开就滚到最底，热门组完全看不到。
   🔴 **只有这一份实现**：画板 `#pfmDrawFontFamily` 与设计台 `#pfmFontSelect` 都用它，别再各写一处。
   ⚠️ 取值为动态：以后热门组换首位自动跟上，不要写死字体名。 */
function hdFontFam(){
  return (HD_FONT_GROUPS[0] && HD_FONT_GROUPS[0].f && HD_FONT_GROUPS[0].f[0]) || 'Arial';
}
function hdFontStrip(fam){ return String(fam==null?'':fam).replace(/^['"]+|['"]+$/g,'').trim(); }
function hdFontVal(fam){ var n=hdFontStrip(fam)||'Arial'; return "'"+n+"'"; }
function hdFontEsc(s){ return String(s).replace(/[&<>"']/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

function hdFontUrl(names){
  return 'https://fonts.googleapis.com/css2?'+names.map(function(n){
    return 'family='+encodeURIComponent(n).replace(/%20/g,'+');
  }).join('&')+'&display=swap';
}
/* ===== 2026-10-01（用户裁决 乙）：字体改为**自托管** —— 本地 woff2 优先，Google 仅作回退 =====
   为什么：① 少 2 个第三方域（googleapis + gstatic）的 DNS/TLS/RTT；② 国内网络下可用（原来 Google 不可达
   时要等满 8s 兜底才落字）；③ 无第三方请求（欧洲 GDPR 有实际判例风险）；④ 跨站缓存优势早已不存在
   （Chrome 86+ HTTP 缓存按 top-level site 分区）。
   🔴 CDN 前缀由 section 注入 `window.HD_FONT_BASE`（本文件是**静态 asset**，拿不到 Liquid 的 asset_url）。
   🔴 版本段写死在**文件名**里 —— 前缀拼接拿不到 asset_url 的 `?v=`，换字体必须递增 HD_FONT_VER 破缓存。
   🔴 本轮只托管 **latin** 子集（120 款 / 2.44MB）；latin-ext 字符会走系统字体（用户裁决 A）。 */
var HD_FONT_VER = 'v1';
function hdFontFileSlug(n){
  return String(n==null?'':n).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
}
/* 生成本地 @font-face 文本；没有前缀（或名字取不到 slug）时返回空 ⇒ 调用方走 Google 回退 */
function hdFontLocalFace(name){
  var base = window.HD_FONT_BASE || '';
  var s = hdFontFileSlug(name);
  if(!base || !s) return '';
  var fam = String(name).replace(/\\/g,'\\\\').replace(/'/g,"\\'");
  return "@font-face{font-family:'"+fam+"';font-style:normal;font-weight:400;font-display:swap;"
       + "src:url("+base+"hf-"+s+"-"+HD_FONT_VER+"-l.woff2) format('woff2');}";
}
function hdFontInject(names){
  return new Promise(function(res){
    if(!names||!names.length) return res(false);
    var done=false; function fin(v){ if(done)return; done=true; res(v); }
    function google(){
      var l=document.createElement('link');
      l.rel='stylesheet'; l.href=hdFontUrl(names); l.setAttribute('data-hdfont','1');
      l.onload=function(){ fin(true); }; l.onerror=function(){ fin(false); };
      /* 2026-10-01：8s → 2.5s —— 自托管后这条只在「本地文件缺失/回退 Google」时才走，不该让人干等 */
      setTimeout(function(){ fin(true); },2500);
      document.head.appendChild(l);
    }
    var css='';
    for(var i=0;i<names.length;i++){
      var f=hdFontLocalFace(names[i]);
      if(f) css+=f;
    }
    if(!css){ google(); return; }
    var st=document.createElement('style');
    st.setAttribute('data-hdfont','1'); st.textContent=css;
    document.head.appendChild(st);
    /* 本地文件 404 / 加载失败 ⇒ document.fonts.load 会 reject ⇒ 回退 Google（不让人卡住）
       ⚠️ 现网调用点都是**单款**加载 ⇒ 只校验首个；若将来有多款批量，这里要改成逐个校验。 */
    var to=setTimeout(google, 2500);
    try{
      document.fonts.load('16px "'+hdFontStrip(names[0])+'"').then(function(fs){
        clearTimeout(to);
        if(fs && fs.length) fin(true); else google();
      }).catch(function(){ clearTimeout(to); google(); });
    }catch(e){ clearTimeout(to); google(); }
  });
}
/* ⚠️ 这个函数曾经写错并导致「字体永远不下载」，务必看清：
   document.fonts.check() 对**完全没有 @font-face 定义**的字体族返回 **true**（规范如此），
   所以它不能单独用来判断「就绪」。必须先确认该族已在 FontFaceSet 里注册过。
   否则 hdFontLoad 每次都误判「已就绪」直接 return → link 从不注入 → 静默 fallback。 */
function hdFontReady(fam){
  var n=hdFontStrip(fam); if(!n) return true;
  var k=n.toLowerCase();
  if(HD_SYS_FONTS[k]) return true;      /* 系统字体：天然可用，无需下载 */
  if(hdFontLoaded[n]) return true;      /* 已经触发过加载 */
  try{
    var set=document.fonts;
    if(!set) return true;
    var has=false;
    if(set.forEach){ set.forEach(function(f){ if(f.family && hdFontStrip(f.family).toLowerCase()===k) has=true; }); }
    if(!has) return false;
    return set.check('16px "'+n+'"');
  }catch(e){ return true; }
}
function hdFontLoad(fam){
  var n=hdFontStrip(fam); if(!n) return Promise.resolve();
  if(hdFontLoaded[n]) return Promise.resolve();
  if(hdFontReady(n)){ hdFontLoaded[n]=1; return Promise.resolve(); }
  hdFontLoaded[n]=1;
  var p=hdFontInject([n]).then(function(){
    try{ return document.fonts.load('16px "'+n+'"'); }catch(e){}
  }).catch(function(){});
  hdFontPending.push(p);
  return p;
}
function hdFontsReady(){
  if(!hdFontPending.length) return Promise.resolve();
  return Promise.all(hdFontPending.slice()).catch(function(){});
}
function hdFontPreconnect(){
  try{
    if(document.querySelector('link[data-hdfont-pc]')) return;
    var hosts=['https://fonts.googleapis.com','https://fonts.gstatic.com'];
    for(var i=0;i<hosts.length;i++){
      var l=document.createElement('link'); l.rel='preconnect'; l.href=hosts[i];
      if(i) l.crossOrigin='';
      l.setAttribute('data-hdfont-pc','1');
      document.head.appendChild(l);
    }
  }catch(e){}
}

function hdFontBuildOptions(){
  var sel=q('pfmFontSelect'); if(!sel||sel.getAttribute('data-hdbuilt')) return;
  sel.setAttribute('data-hdbuilt','1');
  var seen={}, html='';
  HD_FONT_GROUPS.forEach(function(grp){
    var items=[];
    grp.f.forEach(function(n){ var k=n.toLowerCase(); if(seen[k])return; seen[k]=1; items.push(n); });
    if(!items.length) return;
    html+='<optgroup label="'+hdFontEsc(grp.g)+'">';
    items.forEach(function(n){ html+='<option value="'+hdFontEsc(hdFontVal(n))+'">'+hdFontEsc(n)+'</option>'; });
    html+='</optgroup>';
  });
  sel.innerHTML=html;
  sel.value=hdFontVal(hdFontFam());   /* 2026-10-01：默认 = 热门第一个（原硬编码 'Arial'，与画板下拉不一致） */
}
function hdFontFillDrawSelect(){
  var sel=q('pfmDrawFontFamily'); if(!sel||sel.getAttribute('data-hdbuilt')) return;
  sel.setAttribute('data-hdbuilt','1');
  /* 2026-10-01（用户裁决 甲）：默认字体 = **★Popular 第一个**。
     原来首项硬编码 Arial、并把 sel.value 也设成 Arial —— 而 Arial 属**最后一组 System**，
     经引擎 hdDrawFontsFill() 的 keep 传递后落在列表**末尾**（实测 selectedIndex=160/160）
     ⇒ 一打开下拉就滚到最底，热门组根本看不到（用户报「默认字体不是从热门开始？」）。
     ⚠️ Arial **仍保留**在全量列表的 System 组里可手选（本地字体、无需联网），只是不再当默认。
     ⚠️ 取值为动态：以后热门组换首位，这里自动跟上，不要再写死字体名。 */
  var _first = hdFontFam();
  var seen={}, n=0, html='<option value="'+hdFontEsc(hdFontVal(_first))+'">'+hdFontEsc(_first)+'</option>';
  seen[_first.toLowerCase()]=1;   /* 首项已占位 ⇒ 下面的循环跳过它，避免重复一项 */
  var groups=HD_FONT_GROUPS.slice(0,HD_FONT_GROUPS.length-1);
  for(var gi=0; gi<groups.length && n<40; gi++){
    var f=groups[gi].f;
    for(var i=0;i<f.length && n<40;i++){
      var name=f[i], k=name.toLowerCase();
      if(seen[k]) continue; seen[k]=1; n++;
      html+='<option value="'+hdFontEsc(hdFontVal(name))+'">'+hdFontEsc(name)+'</option>';
    }
  }
  sel.innerHTML=html;
  sel.value=hdFontVal(_first);   /* 2026-10-01 甲：默认 = 热门第一个（原为 'Arial'） */
}
function hdFontSyncUI(){
  var sel=q('pfmFontSelect'), nm=q('pfmFontTriggerName');
  if(!sel||!nm) return;
  var v=hdFontStrip(sel.value)||'Arial';
  nm.textContent=v;
  nm.style.fontFamily=hdFontReady(v)?"'"+v+"'":'';
  var list=q('pfmFontList');
  if(list){
    var items=list.querySelectorAll('.pfm-fontpick-item');
    for(var i=0;i<items.length;i++) items[i].classList.toggle('sel', items[i].getAttribute('data-name')===v);
  }
}
function hdFontRender(query){
  var list=q('pfmFontList'); if(!list) return;
  var qy=String(query==null?'':query).trim().toLowerCase();
  var seen={}, html='', total=0;
  HD_FONT_GROUPS.forEach(function(grp){
    var items=[];
    grp.f.forEach(function(n){
      var k=n.toLowerCase(); if(seen[k])return; seen[k]=1;
      if(qy && k.indexOf(qy)<0) return;
      items.push(n);
    });
    if(!items.length) return;
    total+=items.length;
    html+='<div class="pfm-fontpick-grp">'+hdFontEsc(grp.g)+'</div>';
    items.forEach(function(n){
      var sty=hdPrevNames[n]?(' style="font-family:\''+hdFontEsc(n)+'\'"'):'';
      html+='<div class="pfm-fontpick-item" role="option" data-name="'+hdFontEsc(n)+'"'+sty+'>'+hdFontEsc(n)+'</div>';
    });
  });
  list.innerHTML = total ? html : '<div class="pfm-fontpick-empty">No font matches "'+hdFontEsc(qy)+'"</div>';
  hdFontSyncUI();
}
function hdFontIsOpen(){ var pk=q('pfmFontPick'); return !!(pk&&pk.classList.contains('open')); }
function hdFontReposition(){
  var pop=q('pfmFontPop'), tr=q('pfmFontPick');
  if(!pop||!tr||!hdFontIsOpen()) return;
  var r=tr.getBoundingClientRect();
  var vw=window.innerWidth||document.documentElement.clientWidth;
  var vh=window.innerHeight||document.documentElement.clientHeight;
  var width=Math.min(Math.max(Math.round(r.width),260), Math.max(240,vw-16));
  var left=Math.min(Math.max(8,Math.round(r.left)), Math.max(8,vw-width-8));
  var below=vh-Math.round(r.bottom)-8, above=Math.round(r.top)-8;
  var h=Math.max(150,Math.min(340, Math.max(below,above)-4));
  pop.style.width=width+'px';
  pop.style.left=left+'px';
  pop.style.maxHeight=h+'px';
  if(below>=above){ pop.style.top=(Math.round(r.bottom)+4)+'px'; pop.style.bottom='auto'; }
  else { pop.style.top='auto'; pop.style.bottom=((vh-Math.round(r.top))+4)+'px'; }
}
function hdFontPreviewLoad(){
  if(hdFontPrevStarted) return; hdFontPrevStarted=true;
  var pop=HD_FONT_GROUPS[0].f, batches=[], i;
  for(i=0;i<pop.length;i+=10) batches.push(pop.slice(i,i+10));
  batches.forEach(function(b,bi){
    setTimeout(function(){
      hdFontInject(b).then(function(){
        b.forEach(function(n){ hdPrevNames[n]=1; });
        if(hdFontIsOpen()) hdFontRender(q('pfmFontSearch')?q('pfmFontSearch').value:'');
      });
    }, bi*320);
  });
}
function hdFontOpen(){
  var pk=q('pfmFontPick'), pop=q('pfmFontPop'); if(!pk||!pop) return;
  pk.classList.add('open'); pk.setAttribute('aria-expanded','true');
  var srch=q('pfmFontSearch'); if(srch) srch.value='';
  hdFontRender('');
  pop.style.display='flex';
  hdFontReposition();
  hdFontPreviewLoad();
}
function hdFontClose(){
  var pk=q('pfmFontPick'), pop=q('pfmFontPop'); if(!pk||!pop) return;
  pk.classList.remove('open'); pk.setAttribute('aria-expanded','false');
  pop.style.display='none';
}
function hdFontToggle(){ hdFontIsOpen()?hdFontClose():hdFontOpen(); }
function hdFontPick(name){
  var sel=q('pfmFontSelect'); if(!sel||!name) return;
  var v=hdFontVal(name);
  sel.value=v;
  if(sel.value!==v){
    var op=document.createElement('option'); op.value=v; op.textContent=name;
    sel.appendChild(op); sel.value=v;
  }
  hdFontClose();
  hdFontSyncUI();
  var nm=q('pfmFontTriggerName');
  hdFontLoad(v).then(function(){
    if(nm) nm.style.fontFamily="'"+name+"'";
    hdFontSyncUI();
  });
  try{ sel.dispatchEvent(new Event('change',{bubbles:true})); }catch(e){}
}
function hdFontBind(){
  var tr=q('pfmFontPick'), srch=q('pfmFontSearch'), list=q('pfmFontList');
  if(tr) tr.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); hdFontToggle(); });
  if(srch) srch.addEventListener('input',function(){ hdFontRender(this.value); });
  if(list) list.addEventListener('click',function(e){
    var t=e.target, it=null;
    while(t && t!==list){ if(t.classList && t.classList.contains('pfm-fontpick-item')){ it=t; break; } t=t.parentNode; }
    if(it) hdFontPick(it.getAttribute('data-name'));
  });
  document.addEventListener('pointerdown',function(e){
    if(!hdFontIsOpen()) return;
    var pk=q('pfmFontPick'), pop=q('pfmFontPop');
    if((pk&&pk.contains(e.target))||(pop&&pop.contains(e.target))) return;
    hdFontClose();
  },true);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&hdFontIsOpen()) hdFontClose(); });
  window.addEventListener('resize',hdFontReposition,{passive:true});
  window.addEventListener('scroll',hdFontReposition,true);
}
function hdFontInit(){
  hdFontPreconnect();
  hdFontBuildOptions();
  hdFontFillDrawSelect();
  hdFontRender('');
  hdFontBind();
  hdFontSyncUI();
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',hdFontInit);
else hdFontInit();

/* 暴露到 window —— 本文件是独立 asset，section 的主 IIFE 看不到这里的作用域。
   同 window.__pfmSaveState 的教训：跨作用域必须显式暴露，禁止用 typeof 探测猜。 */
window.__hdFontLoad=hdFontLoad;
window.__hdFontReady=hdFontReady;
window.__hdFontsReady=hdFontsReady;
window.__hdFontVal=hdFontVal;
window.__hdFontSyncUI=hdFontSyncUI;
window.__hdFontGroups=HD_FONT_GROUPS;
window.__hdFontIsOpen=hdFontIsOpen;
window.__hdFontClose=hdFontClose;
window.__hdFontPick=hdFontPick;
})();
